module.exports = __webpack_public_path__ + "img/32.ccd6e03d.png";